import 'vant/lib/stepper/index.less'

// 依赖
import '../preview-text/style'
